/** Une couleur par classe de répondant : l'échelle dit d'un coup d'œil ce que vaut la note. */
export const GRADUATED_COLORS = 'GRADUATED_COLORS';

/** Une seule couleur, celle des réponses : la question ne juge plus la note qu'on lui donne. */
export const NEUTRAL_COLOR = 'NEUTRAL_COLOR';

/**
 * Comment les crans d'une question notée se colorent.
 *
 * Le mode n'est pas une donnée à part du brouillon : il se lit dans le drapeau que porte l'habillage
 * de l'élément — `customColor` pour une recommandation, `customColors` pour une satisfaction —, qui
 * dit si les couleurs de l'élément priment sur celle des réponses. Il n'existe que pour le
 * paramétrage, où l'utilisateur choisit entre les deux.
 */
export type RatedColorMode = typeof GRADUATED_COLORS | typeof NEUTRAL_COLOR;
